if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.initEngraving();
      }
       initEngraving() {
        const setup = (selectId, inputId, labelId) => {
          const select = this.querySelector(`#${selectId}`);
          const input = this.querySelector(`#${inputId}`);
          const label = this.querySelector(`#${labelId}`);

          if (!select || !input) return;

          const updateState = () => {
            const isDisabled = select.value === 'No Engraving';

            // Toggle visibility
            if (label) label.style.display = isDisabled ? 'none' : 'block';
            input.style.display = isDisabled ? 'none' : 'block';

            // Toggle required
            input.required = !isDisabled;

            // Clear value if disabled
            if (isDisabled) input.value = '';

            // Apply font
            const selectedOption = select.options[select.selectedIndex];
            const font = selectedOption.getAttribute('data-fontname');

            if (font && font !== 'No Engraving') {
              input.style.fontFamily = font;
            }
          };

          // Init + event
          updateState();
          select.addEventListener('change', updateState);
        };

        setup(
          'select-engraving-font-front',
          'engraving-text-front',
          'engraving-text-front-label'
        );

        setup(
          'select-engraving-font-back',
          'engraving-text-back',
          'engraving-text-back-label'
        );
      }


      // onSubmitHandler(evt) {
      //   evt.preventDefault();
      //   if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      //   this.handleErrorMessage();

      //   this.submitButton.setAttribute('aria-disabled', true);
      //   this.submitButton.classList.add('loading');
      //   this.querySelector('.loading__spinner').classList.remove('hidden');

      //   const config = fetchConfig('javascript');
      //   config.headers['X-Requested-With'] = 'XMLHttpRequest';
      //   delete config.headers['Content-Type'];

      //   const formData = new FormData(this.form);
      //   if (this.cart) {
      //     formData.append(
      //       'sections',
      //       this.cart.getSectionsToRender().map((section) => section.id)
      //     );
      //     formData.append('sections_url', window.location.pathname);
      //     this.cart.setActiveElement(document.activeElement);
      //   }
      //   config.body = formData;

      //   fetch(`${routes.cart_add_url}`, config)
      //     .then((response) => response.json())
      //     .then((response) => {
      //       if (response.status) {
      //         publish(PUB_SUB_EVENTS.cartError, {
      //           source: 'product-form',
      //           productVariantId: formData.get('id'),
      //           errors: response.errors || response.description,
      //           message: response.message,
      //         });
      //         this.handleErrorMessage(response.description);

      //         const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
      //         if (!soldOutMessage) return;
      //         this.submitButton.setAttribute('aria-disabled', true);
      //         this.submitButtonText.classList.add('hidden');
      //         soldOutMessage.classList.remove('hidden');
      //         this.error = true;
      //         return;
      //       } else if (!this.cart) {
      //         window.location = window.routes.cart_url;
      //         return;
      //       }

      //       const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
      //       if (!this.error)
      //         publish(PUB_SUB_EVENTS.cartUpdate, {
      //           source: 'product-form',
      //           productVariantId: formData.get('id'),
      //           cartData: response,
      //         }).then(() => {
      //           CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
      //         });
      //       this.error = false;
      //       const quickAddModal = this.closest('quick-add-modal');
      //       if (quickAddModal) {
      //         document.body.addEventListener(
      //           'modalClosed',
      //           () => {
      //             setTimeout(() => {
      //               CartPerformance.measure("add:paint-updated-sections", () => {
      //                 this.cart.renderContents(response);
      //               });
      //             });
      //           },
      //           { once: true }
      //         );
      //         quickAddModal.hide(true);
      //       } else {
      //         CartPerformance.measure("add:paint-updated-sections", () => {
      //           this.cart.renderContents(response);
      //         });
      //       }
      //     })
      //     .catch((e) => {
      //       console.error(e);
      //     })
      //     .finally(() => {
      //       this.submitButton.classList.remove('loading');
      //       if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
      //       if (!this.error) this.submitButton.removeAttribute('aria-disabled');
      //       this.querySelector('.loading__spinner').classList.add('hidden');

      //       CartPerformance.measureFromEvent("add:user-action", evt);
      //     });
      // }
      onSubmitHandler(evt) {
  evt.preventDefault();

  if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

  this.handleErrorMessage();

  // 🔥 GET ENGRAVING VALUES (GLOBAL QUERY = safer)
  const frontFont = document.getElementById('select-engraving-font-front')?.value || 'No Engraving';
  const backFont = document.getElementById('select-engraving-font-back')?.value || 'No Engraving';
  const isSingleEngraving = document.getElementById("single-engraving");

  // gift handler
  let isGifted = 'No';
  let giftProductId = '';
  let combinedWith = '';

  const giftInput = document.getElementById("add_gift_product");

  if (giftInput) {
      isGifted = giftInput.dataset.isGifted || 'No';
      giftProductId = giftInput.dataset.giftProductId || '';
      combinedWith = giftInput.dataset.combinedWith || '';

      // console.log('atc isGifted ', isGifted);
      // console.log('giftProductId ', giftProductId);
      // console.log('combinedWith ', combinedWith);
  }

  const frontText = document.getElementById('engraving-text-front')?.value || '';
  const backText = document.getElementById('engraving-text-back')?.value || '';
  const engravingVariant = document.getElementById('engraving_variant_id')?.value || '';
  this.submitButton.setAttribute('aria-disabled', true);
  this.submitButton.classList.add('loading');
  this.querySelector('.loading__spinner').classList.remove('hidden');

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  const formData = new FormData(this.form);
  /* =========================
    ENGRAVING DATA
  ========================= */
  const internalVariantId =
    document.getElementById('engraving-text-front')?.dataset.variantId || '';

  const externalVariantId =
    document.getElementById('engraving-text-back')?.dataset.variantId || '';

  const hasInternal =
    frontFont !== 'No Engraving' &&
    frontText.trim() !== '';

  const hasExternal =
    backFont !== 'No Engraving' &&
    backText.trim() !== '';

  if (hasInternal) {
    formData.set(
      'properties[Engraving Font (Internal)]',
      frontFont
    );

    formData.set(
      'properties[Engraving Text (Internal)]',
      frontText
    );
  }

  if (hasExternal) {
    formData.set(
      'properties[Engraving Font (External)]',
      backFont
    );

    formData.set(
      'properties[Engraving Text (External)]',
      backText
    );
  }
  // 🔥 FORCE SET PROPERTIES (THIS IS THE KEY FIX)
  // formData.set('properties[Engraving Font (Front)]', frontFont);
  // if(!isSingleEngraving) {
  //   formData.set('properties[Engraving Font (Back)]', backFont);
  // }
  // const engravingStyle =
  // document.getElementById('select-engraving-style')?.value || '';

  // // Internal = Front
  // if (engravingStyle === 'internal') {

  //   formData.set(
  //     'properties[Engraving Font (Internal)]',
  //     frontFont
  //   );

  //   formData.delete(
  //     'properties[Engraving Font (External)]'
  //   );

  // }

  // // External = Back
  // else if (engravingStyle === 'external') {

  //   formData.set(
  //     'properties[Engraving Font (External)]',
  //     frontFont
  //   );

  //   formData.delete(
  //     'properties[Engraving Font (Internal)]'
  //   );

  // }

  // // Fallback
  // else {

  //   formData.set(
  //     'properties[Engraving Font (Internal)]',
  //     frontFont
  //   );

  // }

  // // const engravingStyle =
  // // document.getElementById('select-engraving-style')?.value || '';

  //     const propertyKey =
  //       engravingStyle === 'external'
  //         ? 'properties[Engraving Text (External)]'
  //         : 'properties[Engraving Text (Internal)]';

  //     formData.delete('properties[Engraving Text (Internal)]');
  //     formData.delete('properties[Engraving Text (External)]');

  //     if (frontText.trim()) {
  //       formData.set(propertyKey, frontText);
  //     }
  //     formData.delete('properties[Engraving Font (Internal)]');
  //     formData.delete('properties[Engraving Font (External)]');

  //     if (frontFont !== 'No Engraving') {

  //       const fontKey =
  //         engravingStyle === 'external'
  //           ? 'properties[Engraving Font (External)]'
  //           : 'properties[Engraving Font (Internal)]';

  //       formData.set(fontKey, frontFont);
  //     }

 

  // 🔥 DEBUG (VERY IMPORTANT)
  console.log('ENGRAVING DEBUG:', {
    frontFont,
    frontText,
    backFont,
    backText
  });

  if (this.cart) {
    formData.append(
      'sections',
      this.cart.getSectionsToRender().map((section) => section.id)
    );
    formData.append('sections_url', window.location.pathname);
    this.cart.setActiveElement(document.activeElement);
  }
  // console.log('ENGRAVING STYLE:', engravingStyle);

  for (const [key, value] of formData.entries()) {
    console.log(key, value);
  }

  config.body = formData;

  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then(async(response) => {
      console.log('CART RESPONSE:', response);

      if (response.status) {
        this.handleErrorMessage(response.description);
        return;
      }

      if (hasInternal && internalVariantId) {
          await addExtraProduct({
            variantId: internalVariantId,
            quantity: 1,
            combined_with: response.key
          });
        }

        if (hasExternal && externalVariantId) {
          await addExtraProduct({
            variantId: externalVariantId,
            quantity: 1,
            combined_with: response.key
          });
        }
        if (isGifted === 'yes' && giftProductId) {
        await addExtraProduct({
          variantId: giftProductId,
          quantity: 1,
          combined_with: response.key
        });
}

      if (!this.cart) {
        window.location = window.routes.cart_url;
        return;
      }

      this.cart.renderContents(response);
    })
    .catch((e) => console.error(e))
    .finally(() => {
      this.submitButton.classList.remove('loading');
      this.submitButton.removeAttribute('aria-disabled');
      this.querySelector('.loading__spinner').classList.add('hidden');
    });

    async function addExtraProduct({ variantId, quantity = 1, combined_with }) {
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', quantity);
      formData.append('properties[combined_with]', combined_with);
      formData.append('properties[Engraving Product]', 'True');

      try {
        const res = await fetch(routes.cart_add_url, {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        });
        const data = await res.json();
        console.log('EXTRA PRODUCT ADDED:', data);
        return data;
      } catch (err) {
        console.error('EXTRA PRODUCT ERROR:', err);
      }
    }
}

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
